import React from 'react';
interface Props {
  fillColor?: string;
}
function ExerciseIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none">
      <path
        d="M4 3C4 2.03438 4.78438 1.25 5.75 1.25H6.25C7.21562 1.25 8 2.03438 8 3V7.5H12V3C12 2.03438 12.7844 1.25 13.75 1.25H14.25C15.2156 1.25 16 2.03438 16 3V3.5H16.75C17.7156 3.5 18.5 4.28437 18.5 5.25V7.5H19.25C19.6656 7.5 20 7.83437 20 8.25C20 8.66563 19.6656 9 19.25 9H18.5V11.25C18.5 12.2156 17.7156 13 16.75 13H16V13.5C16 14.4656 15.2156 15.25 14.25 15.25H13.75C12.7844 15.25 12 14.4656 12 13.5V9H8V13.5C8 14.4656 7.21562 15.25 6.25 15.25H5.75C4.78438 15.25 4 14.4656 4 13.5V13H3.25C2.28437 13 1.5 12.2156 1.5 11.25V9H0.75C0.334375 9 0 8.66563 0 8.25C0 7.83437 0.334375 7.5 0.75 7.5H1.5V5.25C1.5 4.28437 2.28437 3.5 3.25 3.5H4V3ZM5.5 3.5V4.25V12.25V13V13.5C5.5 13.6375 5.6125 13.75 5.75 13.75H6.25C6.3875 13.75 6.5 13.6375 6.5 13.5V3C6.5 2.8625 6.3875 2.75 6.25 2.75H5.75C5.6125 2.75 5.5 2.8625 5.5 3V3.5ZM4 5H3.25C3.1125 5 3 5.1125 3 5.25V11.25C3 11.3875 3.1125 11.5 3.25 11.5H4V5ZM14.5 12.25V4.25V3.5V3C14.5 2.8625 14.3875 2.75 14.25 2.75H13.75C13.6125 2.75 13.5 2.8625 13.5 3V13.5C13.5 13.6375 13.6125 13.75 13.75 13.75H14.25C14.3875 13.75 14.5 13.6375 14.5 13.5V13V12.25ZM16.75 11.5C16.8875 11.5 17 11.3875 17 11.25V5.25C17 5.1125 16.8875 5 16.75 5H16V11.5H16.75Z"
        fill={fillColor}
      />
    </svg>
  );
}

export default ExerciseIcon;
